// 公司名称
export const COMPANY_NAME = '深圳新辉实业有限公司';

// 导航菜单
export const NAV = [
  {id: 1, name: '首页', url: '/'},
  {id: 2, name: '新辉新闻', url: '/news'},
  {id: 3, name: '关于新辉', url: '/about'},
  {id: 4, name: '新辉产品', url: '/product'},
  {id: 5, name: '行业应用', url: '/industry'},
  {id: 6, name: '服务支持', url: '/service'},
  {id: 7, name: '合作伙伴', url: '/partner'},
  {id: 8, name: '招贤纳士', url: '/recruit'},
  {id: 9, name: '联系新辉', url: '/contact'}
];

// 轮播广告
export const SLIDER = [
  {id: 1, img: 'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3639567276,4293636510&fm=26&gp=0.jpg', url: ''},
  {id: 2, img: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2130888191,2634520338&fm=26&gp=0.jpg', url: ''},
  {id: 3, img: 'https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3446682468,2894165811&fm=26&gp=0.jpg', url: ''}
];


// WEBPACK FOOTER //
// ./src/assets/js/config.js